import { atom } from 'jotai';
import { LAUNCHES_PER_GAME, BlinkoMode } from '../game-engine/constants';

export type GameState = 'waiting' | 'playing' | 'bonus' | 'levelup' | 'maxlevel' | 'gameover';

// Character Animation Types
export type CharacterAnimation = 'idle' | 'puke-single' | 'puke-start' | 'puke-hold' | 'puke' | 'puke-end';
export type CharacterChargeState = 'idle' | 'charging' | 'ready';

// Game Status
export const atomGameState = atom<GameState>('waiting');
export const atomGameMode = atom<BlinkoMode>('main');
export const atomIsGamePreparing = atom<boolean>(false);

// Game Progression
export const atomLevel = atom<number>(1);
export const atomAchievedLevel = atom<number>(1);
export const atomExperience = atom<number>(0);
export const atomLevelProgress = atom<number>(0);

// Ball State
export const atomBallsRemaining = atom<number>(LAUNCHES_PER_GAME);
export const atomTotalBallsUsed = atom<number>(0);
export const atomActiveBallCount = atom<number>(0);
export const atomSpecialHitsCount = atom<number>(0);
export const atomSessionHits = atom<number[]>([]);

// Economy & Stats
export const atomHoneyEarned = atom<number>(0);
export const atomCollectHoneyTrigger = atom<number>(0);
export const atomTotalWinEth = atom<bigint>(0n);
export const atomWageredEth = atom<bigint>(0n);
export const atomEthPrice = atom<number>(0);

// UI State
export const atomRecentBins = atom<string[]>([]);
export const atomUiHidden = atom<boolean>(false);
export const atomGameTheme = atom<'day' | 'night'>('day');
export const atomShowMachinary = atom<boolean>(false);

export const atomBoardReady = atom<boolean>(false);
export const atomControlsReady = atom<boolean>(false);
export const atomIsReplayMode = atom(false);

// Character Animation State
export const atomCharacterChargeState = atom<CharacterChargeState>('idle');
export const atomCharacterChargeProgress = atom<number>(0);
export const atomCharacterDropQueue = atom<Array<() => void>>([]); // queue of drop callbacks
